// src/context/GlobalContext.js
import React, { createContext, useState } from 'react';

// Create the context
export const ColoredContext = createContext(); // Correct naming convention

// Create a provider component
export const ColoredProvider = ({ children }) => {
  const [currentColor, setCurrentColor] = useState({ light: false }); // Initialize state properly

  return (
    <ColoredContext.Provider value={{ currentColor, setCurrentColor }}>
      {children}
    </ColoredContext.Provider>
  );
};
